import React from "react"
import { useTranslation } from "react-i18next"
import { Radio } from "ui/Radio"
import { PRICING_TYPES } from "../../utils/constants"
import { Form } from "antd"

export const PricingTypeSelector = ({ value, setPricingType, form }) => {
  const [t] = useTranslation()
  const onChangeHandler = (e) => {
    const pricingType = e.target.value
    form.setFieldValue("pricing_type", pricingType)
    setPricingType(pricingType)
  }
  return (
    <div>
      <Form.Item name="pricing_type" className="mb-0"></Form.Item>
      <div className="flex flex-wrap gap-3">
        <Radio checked={value === PRICING_TYPES.PER_PERSON} onChange={onChangeHandler} value={PRICING_TYPES.PER_PERSON}>
          {t("trip.pricing_types.charge_per_person")}
        </Radio>
        <Radio checked={value === PRICING_TYPES.FLAT_RATE} onChange={onChangeHandler} value={PRICING_TYPES.FLAT_RATE}>
          {t("trip.pricing_types.charge_flat_rate")}
        </Radio>
      </div>
    </div>
  )
}
